function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueInfoRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35620_39769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.2249C6.5878 11.2249 7.65117 10.9023 8.55564 10.2979C9.46011 9.69359 10.1651 8.83461 10.5813 7.82961C10.9976 6.82462 11.1065 5.71875 10.8943 4.65186C10.6821 3.58496 10.1583 2.60496 9.38909 1.83577C8.6199 1.06658 7.63989 0.542756 6.573 0.330537C5.5061 0.118318 4.40023 0.227237 3.39524 0.643519C2.39025 1.0598 1.53126 1.76475 0.926917 2.66922C0.322569 3.57369 0 4.63706 0 5.72486C0.00157716 7.18306 0.581546 8.58109 1.61265 9.6122C2.64376 10.6433 4.04179 11.2233 5.5 11.2249ZM5.5 2.51652C5.63597 2.51652 5.7689 2.55684 5.88195 2.63239C5.99501 2.70793 6.08313 2.8153 6.13517 2.94093C6.1872 3.06655 6.20082 3.20479 6.17429 3.33815C6.14776 3.47151 6.08228 3.59401 5.98614 3.69016C5.88999 3.78631 5.76749 3.85178 5.63412 3.87831C5.50076 3.90484 5.36253 3.89122 5.23691 3.83919C5.11128 3.78715 5.00391 3.69904 4.92836 3.58598C4.85282 3.47292 4.8125 3.34 4.8125 3.20402C4.8125 3.02169 4.88493 2.84682 5.01386 2.71789C5.1428 2.58896 5.31766 2.51652 5.5 2.51652ZM5.04167 4.80819H5.5C5.74312 4.80819 5.97627 4.90477 6.14818 5.07667C6.32009 5.24858 6.41667 5.48174 6.41667 5.72486V8.47486C6.41667 8.59641 6.36838 8.71299 6.28242 8.79895C6.19647 8.8849 6.07989 8.93319 5.95833 8.93319C5.83678 8.93319 5.7202 8.8849 5.63424 8.79895C5.54829 8.71299 5.5 8.59641 5.5 8.47486V5.72486H5.04167C4.92011 5.72486 4.80353 5.67657 4.71758 5.59061C4.63162 5.50466 4.58333 5.38808 4.58333 5.26652C4.58333 5.14497 4.63162 5.02839 4.71758 4.94243C4.80353 4.85648 4.92011 4.80819 5.04167 4.80819Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35620_39769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.224854)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfoRound);
export default __webpack_public_path__ + "static/media/blue-info-round.cfa1bd5f176c4f9e84203e0311a42e22.svg";
export { ForwardRef as ReactComponent };